import React from 'react';
import { Field, useFormikContext } from 'formik';
import { Checkbox } from 'primereact/checkbox';

const TermsOfUseInput = ({ inputName }) => {
  const { values, setFieldValue } = useFormikContext();

  return (
    <div className="flex-center">
      <div className="flex">
        <Field
          name={inputName}
          children={() => {
            return (
              <Checkbox
                checked={values[inputName] === 'ACCEPTED'}
                onChange={() => {
                  setFieldValue(inputName, 'ACCEPTED');
                }}
              />
            );
          }}
        />
        <div className="pl-025">
          <label>Accept</label>
        </div>
      </div>

      <div className="flex pl-1">
        <Field
          name={inputName}
          children={() => {
            return (
              <Checkbox
                checked={values[inputName] === 'DECLINED'}
                onChange={() => {
                  setFieldValue(inputName, 'DECLINED');
                }}
              />
            );
          }}
        />
        <div className="pl-025">
          <label>Decline</label>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUseInput;
